import $ from "jquery";

export default class PlayFilter {
  constructor(element) {
    let filter = function (el) {
      let subjectAllCheck = element.getElementsByClassName(
        "js-filter-subject-all",
      )[0];

      console.log(subjectAllCheck);
      let typeAllCheck = element.getElementsByClassName(
        "js-filter-type-all",
      )[0];
      let checkBoxes = element.getElementsByClassName("js-filter-box-subject");

      // Hide all
      let elements = document.getElementsByClassName("play-search-result");
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = "none";
      }

      // Reset type if checkbox is "show all"
      if (
        el.target.classList.contains("js-filter-subject-all") ||
        el.target.classList.contains("js-filter-type-all")
      ) {
        if (el.target.classList.contains("js-filter-subject-all")) {
          for (var i = 0; i < checkBoxes.length; i++) {
            if (checkBoxes[i].classList.contains("js-filter-box-subject")) {
              checkBoxes[i].checked = false;
            }
          }
        }
        if (
          el.target.classList.contains("js-filter-type-all") ||
          el.target.classList.contains("js-filter-box-type")
        ) {
          let typeCheckboxElements = document.querySelectorAll("#podd, #video");
          for (var i = 0; i < typeCheckboxElements.length; i++) {
            if (
              typeCheckboxElements[i].classList.contains("js-filter-box-type")
            ) {
              typeCheckboxElements[i].checked = false;
            }
          }
        }
      }

      // Show by subject
      if (el.target.checked) {
        let val = el.target.getAttribute("value");
        let elementsToShow = document.getElementsByClassName(val);
        for (var i = 0; i < elementsToShow.length; i++) {
          if (elementsToShow[i].classList.contains(val + "-hide")) {
            elementsToShow[i].classList.remove(val + "-hide");
          }
          elementsToShow[i].classList.add(val + "-show");
        }
      } else {
        let val = el.target.getAttribute("value");
        let elementsToHide = document.getElementsByClassName(val);
        for (var i = 0; i < elementsToHide.length; i++) {
          if (elementsToHide[i].classList.contains(val + "-show")) {
            elementsToHide[i].classList.remove(val + "-show");
          }
          elementsToHide[i].classList.add(val + "-hide");
        }
      }

      let checkBoxesChecked = 0;
      for (var i = 0; i < checkBoxes.length; i++) {
        if (checkBoxes[i].checked) {
          checkBoxesChecked++;
        }
      }

      // Filter on podd and video even if subject matches
      let categoryPodd = document.getElementById("podd");
      let categoryVideo = document.getElementById("video");
      let activeCategories = [];
      if (categoryPodd.checked) {
        activeCategories.push("podd");
      }
      if (categoryVideo.checked) {
        activeCategories.push("video");
      }

      if (checkBoxesChecked > 0) {
        for (var i = 0; i < elements.length; i++) {
          // If element has class containing "show" from above
          if (elements[i].getAttribute("class").match(/[\w-]*show[\w-]*/g)) {
            // Get element type
            let type = elements[i].getAttribute("data-type");
            // See if type is active
            let filter = activeCategories.indexOf(type);
            if (!activeCategories.length <= 0) {
              if (filter > -1) {
                // filtering on type and subject
                elements[i].style.display = "block";
                subjectAllCheck.checked = false;
                typeAllCheck.checked = false;
              }
            } else {
              // filtering on subject only
              elements[i].style.display = "block";
              subjectAllCheck.checked = false;
              typeAllCheck.checked = true;
            }
          }
        }
      } else {
        for (var i = 0; i < elements.length; i++) {
          let type = elements[i].getAttribute("data-type");
          let filter = activeCategories.indexOf(type);
          if (!activeCategories.length <= 0) {
            if (filter > -1) {
              // filtering on type only
              elements[i].style.display = "block";
              subjectAllCheck.checked = true;
              typeAllCheck.checked = false;
            }
          } else {
            // show all
            elements[i].style.display = "block";
            subjectAllCheck.checked = true;
            typeAllCheck.checked = true;
          }
        }
      }
    };

    let checkBoxes = element.getElementsByClassName("js-filter-box");
    for (var i = 0; i < checkBoxes.length; i++) {
      checkBoxes[i].addEventListener("change", filter);
    }

    let resetCheckBoxes = element.querySelectorAll(
      ".js-filter-subject-all, .js-filter-type-all",
    );
    for (var i = 0; i < resetCheckBoxes.length; i++) {
      resetCheckBoxes[i].addEventListener("change", filter);
    }
  }
}
